import { gql } from '@apollo/client'

import { ASSISTANT_FIELDS_FRAGMENT } from './fragments'

export const GET_ASSISTANT_TOOLS = gql`
  query GetAssistantTools($workspaceId: String!) {
    assistantTools(workspaceId: $workspaceId) {
      id
      label
      description
      icon
    }
  }
`

export const GET_USER_ASSISTANTS = gql`
  query GetUserAssistants($workspaceId: String!) {
    userAssistants(workspaceId: $workspaceId) {
      ...AssistantFields
    }
  }
  ${ASSISTANT_FIELDS_FRAGMENT}
`

export const GET_USER_ASSISTANT = gql`
  query GetUserAssistant($assistantId: String!, $workspaceId: String!) {
    userAssistant(assistantId: $assistantId, workspaceId: $workspaceId) {
      ...AssistantFields
    }
  }
  ${ASSISTANT_FIELDS_FRAGMENT}
`

export const GET_ASSISTANT_TIERS = gql`
  query GetAssistantTiers {
    assistantTiers {
      id
      name
      description
      tools
      stripeProductId
    }
  }
`
